// role-permission.map.ts
import { RoleID } from "./role.enum";
import { Permission } from "./permission.enum";

export const ROLE_PERMISSION_MAP: Partial<Record<RoleID, Permission[]>> = {
  [RoleID.ADMIN]: Object.values(Permission),
};
